/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OpenVulnCountSnapshot
 */
export interface OpenVulnCountSnapshot {
    /**
     * 
     * @type {number}
     * @memberof OpenVulnCountSnapshot
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof OpenVulnCountSnapshot
     */
    critical?: number;
    /**
     * 
     * @type {number}
     * @memberof OpenVulnCountSnapshot
     */
    high?: number;
    /**
     * 
     * @type {number}
     * @memberof OpenVulnCountSnapshot
     */
    medium?: number;
    /**
     * 
     * @type {number}
     * @memberof OpenVulnCountSnapshot
     */
    low?: number;
}

/**
 * Check if a given object implements the OpenVulnCountSnapshot interface.
 */
export function instanceOfOpenVulnCountSnapshot(value: object): value is OpenVulnCountSnapshot {
    return true;
}

export function OpenVulnCountSnapshotFromJSON(json: any): OpenVulnCountSnapshot {
    return OpenVulnCountSnapshotFromJSONTyped(json, false);
}

export function OpenVulnCountSnapshotFromJSONTyped(json: any, ignoreDiscriminator: boolean): OpenVulnCountSnapshot {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'] == null ? undefined : json['total'],
        'critical': json['critical'] == null ? undefined : json['critical'],
        'high': json['high'] == null ? undefined : json['high'],
        'medium': json['medium'] == null ? undefined : json['medium'],
        'low': json['low'] == null ? undefined : json['low'],
    };
}

export function OpenVulnCountSnapshotToJSON(json: any): OpenVulnCountSnapshot {
    return OpenVulnCountSnapshotToJSONTyped(json, false);
}

export function OpenVulnCountSnapshotToJSONTyped(value?: OpenVulnCountSnapshot | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'critical': value['critical'],
        'high': value['high'],
        'medium': value['medium'],
        'low': value['low'],
    };
}

